import { IconProps } from 'src/utils/icon';

const OrganiserIcon: React.FC<IconProps> = ({ size = 1, fill = '#2c2a29' }) => (
  <svg
    style={{ fontSize: `${size}rem` }}
    viewBox="0 0 17 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.5 9.5C11.1828 9.5 13.3571 7.37363 13.3571 4.75C13.3571 2.12637 11.1828 0 8.5 0C5.81719 0 3.64286 2.12637 3.64286 4.75C3.64286 7.37363 5.81719 9.5 8.5 9.5ZM11.9 10.6875H11.2663C10.4239 11.066 9.48661 11.2812 8.5 11.2812C7.51339 11.2812 6.57991 11.066 5.73371 10.6875H5.1C2.28437 10.6875 0 12.9215 0 15.675V17.2188C0 18.2021 0.815848 19 1.82143 19H15.1786C16.1842 19 17 18.2021 17 17.2188V15.675C17 12.9215 14.7156 10.6875 11.9 10.6875Z"
      fill={fill}
    />
  </svg>
);

export default OrganiserIcon;
